/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : CartView.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H352615
*
* @Date         : AUG 2, 2019
*
* @Version      : Version 1.0
*
* By            : H352615
* On            : Aug 26, 2019
* Description   : Updated code as ASDS-1084.
* By            : Avanthi G (E860178)
* On            : Sep 06, 2019
* Description   : Sending Dymanic UserID for fetching mycart details service and add to cart service(ASDS-1173)
* By            : H224423
* On            : Sep 27, 2019
* Description   : ASDS-1287 - Cart Popup Alignment, Font, Icon
* By            : H224423
* On            : Oct 10, 2019
* Description   : ASDS-1478 - Icon count changes (getting reseted) on hover issue fix.
* By            : H224423
* On            : Oct 11, 2019
* Description   : ASDS-1478 cart icon reset evertime on cart icon hover issue fix.
*
* By            : E844276
* On            : Oct 16, 2019
* Description   : ASDS-1572 - disable checkout button when cart count is zero.
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes.
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            	: Madhu Gali
 * On            	:  Dec 18, 2019
 * Description  : ASDS-584
 *
 * By            : H224423
 * On            : Jan 02, 2020
 * Description   : Added/updated UT Automation test cases.
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H422336
 * On            : Oct 13, 2020
 * Description   : ASDS-3262, ASDS-3263 UI Enhancements Phase - II
 *
 * By            : H422336
 * On            : Oct, 22 2020
 * Description   : ASDS-3535 UI Enhancements for Phase-II
 *
 * By            : H422336
 * On            : Oct, 22 2020
 * Description   : ASDS-3783 UI Enhancements for Phase-II
 *
******************************************************************************/

import React from 'react';
import { Button, Grid, Icon } from '@scuf/common';
import RouteConstants from '../constants/route-constants';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { CartItem, AbstractCartViewAmount } from '../../../../types';
import CheckoutConstants,{ CheckoutUILabels } from '../constants/checkout-constants';
import { InLineLoader } from '../Loader/Loader';
import { logInfo } from '../../../utils/console-utility';
import CartDetailsActions from '../redux/actions/cart-details-actions';
import ProductAlertActions from '../redux/actions/products-alerts-action';

interface CartViewProps {
    getAbstractCartView: Function;
    cartList?: CartItem[];
    amount?: AbstractCartViewAmount;
    cartCount?: number;
    isFetching: boolean;
    isSuccess: boolean;
    userValidationData: any;
    toggleDeletePopUp: Function;
    toggleCartIcon: Function;
    hideAlert: Function;
}

interface CartViewState {

}

interface CartOptionsProps {
    cartCount?: number;
    toggleCartIcon: Function;
    hideAlert: Function;
}

interface CartAmoutPropsI {
    amountDetails?: AbstractCartViewAmount;
}

interface CartListPropsI {
    cartList: CartItem[];
    toggleDeletePopUp: Function;
    toggleCartIcon: Function;
}
/**
 * @description UI for cart amount details.
 * @param props
 */
function CartAmount(props: CartAmoutPropsI) {
    return (
        <React.Fragment>
            <Grid.Row className="fullwidthRow">
                <Grid.Column width={12} className="cart-sub-total-row">
                    <span className="cv-sub-total-text">{CheckoutUILabels.CART_SUB_TOTAL}</span>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row className="fullwidthRow">
                <Grid.Column width={12} className="fullwidthRow">
                    <span className="cv-sub-total">{props.amountDetails && props.amountDetails.subtotal ? ('$' + props.amountDetails.subtotal) : ''}</span>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={12} className="fullwidthRow">
                    <span className="cv-tax-applicable-text">
                        {CheckoutUILabels.TAXES_SHIPPING_APLICABLE}
                    </span>
                </Grid.Column>
            </Grid.Row>
        </React.Fragment>
    );
}

/**
 * @description Lists all Items in cart.
 * @param props
 */
const CartList = withRouter(class CartListComponent extends React.Component<CartListPropsI & RouteComponentProps> {
    render() {
        return (
            <Grid.Row className="fullwidthRow cart-product-list">
                {this.props.cartList.map((product,index) => (
                    <Grid.Row className="cart-item" key={index}>
                        <Grid.Column width={1} className="fullwidthRow">
                            {product.productName.toLowerCase().includes(CheckoutConstants.APU_PRODUCT_NAME)
                            &&<i className={CheckoutConstants.APU_PRODUCT_CLASSNAME + ' cart-product-icon'}></i>}

                            {product.productName.toLowerCase().includes(CheckoutConstants.ASPIRE_PRODUCT_NAME)
                            &&<i className={CheckoutConstants.ASPIRE_PRODUCT_CLASSNAME + ' cart-product-icon'}></i>}

                            {product.productName.toLowerCase().includes(CheckoutConstants.DLMUW_PRODUCT_NAME)
                            &&<i className={CheckoutConstants.DLMUW_PRODUCT_CLASSNAME + ' cart-product-icon'}></i>}

                            {product.productName.toLowerCase().includes(CheckoutConstants.ANALYZER_SERVICE_CENTERS_PRODUCT_NAME)
                            &&<i className={CheckoutConstants.ANALYZER_PRODUCT_CLASSNAME + ' cart-product-icon'}></i>}

                            {product.productName.toLowerCase().includes(CheckoutConstants.FAULT_ANALYZER_SERVICES_PRODUCT_NAME)
                            &&<i className={CheckoutConstants.FAULT_PRODUCT_CLASSNAME + ' cart-product-icon'}></i>}

                            {product.productName.toLowerCase().includes(CheckoutConstants.REMOTE_TERMINAL_SERVICES_PRODUCT_NAME)
                            &&<i className={CheckoutConstants.REMOTE_TERMINAL_PRODUCT_CLASSNAME + ' cart-product-icon'}></i>}
                        </Grid.Column>
                        <Grid.Column width={8} className="fullwidthRow">
                            <h5>{product.productName}</h5>
                        </Grid.Column>
                        <Grid.Column width={3} className="fullwidthRow">
                            <Grid.Column width={12} className="fullwidthRow">
                                {(this.props.location.pathname !== RouteConstants.SHIPPING_BILLING && this.props.location.pathname !== RouteConstants.REVIEW_ORDER && this.props.location.pathname !== RouteConstants.ORDER_FAILURE) &&
                                    <Icon className="icon-hover cart-price delete" root="common" name="delete" size="small" onClick={() => { this.props.toggleDeletePopUp(true, product); this.props.toggleCartIcon(false); }} />
                                }
                            </Grid.Column>
                            <Grid.Column width={12} className="fullwidthRow">
                                <p className="cart-price-text">${product.amount}</p>
                            </Grid.Column>
                        </Grid.Column>
                    </Grid.Row>)
                )}
            </Grid.Row>
        );
    }
});

/**
 * @description displays checkout options.
 */
const CartOptions = withRouter(class CartOptionsComponent extends React.PureComponent<CartOptionsProps & RouteComponentProps, {}> {

    constructor(props: CartOptionsProps & RouteComponentProps) {
        super(props);
        this.onHandleCheckout = this.onHandleCheckout.bind(this);
        this.onHandleViewCart = this.onHandleViewCart.bind(this);
    }

    onHandleViewCart() {
        this.props.history.push(RouteConstants.MY_CART);
        this.props.toggleCartIcon(false);
        this.props.hideAlert();
    }

    onHandleCheckout() {
        this.props.history.push(RouteConstants.SHIPPING_BILLING);
        this.props.toggleCartIcon(false);
        this.props.hideAlert();
    }

    render() {
        return (
            <Grid.Row className="fullwidthRow">
                <Grid.Column width={12} className="fullwidthRow">
                    <div className="pull-right buttonsFooter">
                        <Button
                            type="secondary"
                            onClick={this.onHandleViewCart}
                            content={CheckoutUILabels.VIEW_CART_BTN}
                            className="view-cart--btn co-secondary-button"
                        />

                        <Button
                            type="primary" disabled={this.props.cartCount === 0}
                            onClick={this.onHandleCheckout}
                            content={CheckoutUILabels.CHECKOUT_BTN}
                            className="checkout--btn co-primary-button cv-checkout-button"
                        />
                    </div>
                </Grid.Column>
            </Grid.Row>
        );
    }
});

/**
 * @author ASDS Team
 * @description Layout for cart content.
 */
class CartView extends React.PureComponent<CartViewProps, CartViewState> {
    componentDidMount() {
        const userId = this.props.userValidationData.payload.userInfo.customer_sub;
        if (!userId) {
            logInfo('Invalid UserId');
        }
        else {
            console.log(userId);
            this.props.getAbstractCartView(userId);
        }
    }
    render() {
        if (this.props.isFetching) {
            return (
                <InLineLoader loading={true} text="Fetching Cart Details" overlayColor="transparent" data-testid="t-CartView-inline-loader">

                </InLineLoader>
            );
        } else if (!this.props.isFetching && !this.props.isSuccess) {
            return (<div>
                Error occurred while fetching cart details. Please try again.
            </div>)
        }
        return (
            <Grid className="fullwidthRow">
                <CartList cartList={this.props.cartList || []} toggleDeletePopUp={this.props.toggleDeletePopUp}  toggleCartIcon={this.props.toggleCartIcon} />
                <CartAmount amountDetails={this.props.amount} />
                <CartOptions cartCount={this.props.cartCount} toggleCartIcon={this.props.toggleCartIcon} hideAlert={this.props.hideAlert} />
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    const { isFetching, isSuccess, cartDetails = {} } = state.cartDetails.abstractView;
    if (!isFetching) {
        // cartDetails:AbstractCartView
        return {
            cartList: cartDetails.cartList ? cartDetails.cartList : [],
            cartCount: cartDetails.cartList ? cartDetails.cartList.length : 0,
            amount: cartDetails.amount ? cartDetails.amount : {},
            isFetching,
            isSuccess,
            userValidationData: state.userValidationData,
            showDeletePopUp: state.cartDetails.showDeletePopUp
        };
    }
    return {
        isFetching, isSuccess, cartList: [], amount: {},
        userValidationData: state.userValidationData,
    };
}
const mapDispatchToProps = {
    getAbstractCartView: CartDetailsActions.getAbstractCartViewWithoutReset,
    toggleDeletePopUp: CartDetailsActions.toggleDeletePopUp,
    toggleCartIcon: CartDetailsActions.toggleCartIcon,
    hideAlert: ProductAlertActions.hideAlert

};

export default connect(mapStateToProps, mapDispatchToProps)(CartView);